import React from 'react';
import Menu from '../../nav/menu';
import Footer from '../../nav/footer';
import useMedia from 'use-media';
import { textArea1, textArea2, textArea3 } from './text';

function PolicyPage() {
  const isLargeScreen = useMedia('(min-width: 601px)');
  const isSmallScreen = useMedia('(max-width: 600px)');

  let mainStyles = {
    display: "flex", justifyContent: "center"
  }

  let policyAndTermsStyle = {
    fontSize: "xx-large"
  }
  let policysStyle = {
    fontSize: "x-large"
  }
  return (
    <div>
      <Menu/>
      {isLargeScreen &&
      <div style={{ width: "100%", justifyContent: "center", display: "flex", backgroundColor: "#F4DFBB" }}>
        <div style={{ display: "flex", maxWidth: "1200px", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", width: "100%", height: "100%", justifyContent: "center" }}>
          <div id="mainArea" style={{ background: "white", border: "1px solid black", borderRadius: "10px", width: "60%", margin: "10px" }}>
            <div style={{ ...mainStyles, marginTop: "10px", marginBottom: "10px" }}>
              <img src="img/companyLogo.png" width="100" height="100" alt="company Logo"/>
            </div>
            <div style={{ ...mainStyles, borderBottom: "1px solid black" }}>
              <span style={{ ...policyAndTermsStyle }}>Policy and term</span>
            </div>
            <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
              <b><span style={{ ...policysStyle }}>Privacy Policy</span></b><br/>
              <span>{textArea1}</span>
            </div>
            <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
              <b><span style={{ ...policysStyle }}>Terms of Service</span></b><br/>
              <span>{textArea2}</span>
            </div>
            <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
              <b><span style={{ ...policysStyle }}>Refound Policy</span></b><br/>
              <span>{textArea3}</span>
            </div>
            <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
              <b><span style={{ ...policysStyle }}>Other kind of Policy</span></b><br/>
              <span>{textArea3}</span>
            </div>
          </div>
        </div>
      </div> 
      }
      {isSmallScreen && 
        <div style={{ width: "100%", justifyContent: "center", display: "flex", backgroundColor: "#F4DFBB" }}>
          <div style={{ display: "flex", maxWidth: "100%", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", width: "100%", height: "100%", justifyContent: "center" }}>
            <div id="mainArea" style={{ background: "white", border: "1px solid black", borderRadius: "10px", width: "95%", marginTop: "10px", marginBottom: "10px" }}>
              <div style={{ ...mainStyles, marginTop: "10px", marginBottom: "10px" }}>
                <img src="img/companyLogo.png" width="100" height="100" alt="company Logo"/>
              </div>
              <div style={{ ...mainStyles, borderBottom: "1px solid black" }}>
                <span style={{ ...policyAndTermsStyle }}>Policy and term</span>
              </div>
              <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
                <b><span style={{ ...policysStyle }}>Privacy Policy</span></b><br/>
                <span>{textArea1}</span>
              </div>
              <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
                <b><span style={{ ...policysStyle }}>Terms of Service</span></b><br/>
                <span>{textArea2}</span>
              </div>
              <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
                <b><span style={{ ...policysStyle }}>Refound Policy</span></b><br/>
                <span>{textArea3}</span>
              </div>
              <div style={{ ...mainStyles, flexFlow: "column", padding: "10px" }}>
                <b><span style={{ ...policysStyle }}>Other kind of Policy</span></b><br/>
                <span>{textArea3}</span>
              </div>
            </div>
          </div>
        </div>
      }
      <Footer/>
    </div>
  )
}

export default PolicyPage;